<template>
  <el-drawer
    :visible.sync="localVisible"
    :size="drawerSize"
    direction="rtl"
    :with-header="true"
    @close="handleClose"
  >
    <template slot="title">
      <span class="drawer-title">提现详情</span>
    </template>
    
    <div v-if="withdrawData" class="drawer-content">
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="商户名称">
          <span class="detail-value">{{ withdrawData.merchantName }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="打款账号">
          <span class="detail-value">{{ withdrawData.accountNumber }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="手机号码">
          <span class="detail-value">{{ withdrawData.phoneNumber }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="提现金额">
          <span class="detail-value highlight">¥{{ withdrawData.withdrawAmount }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="剩余可提金额">
          <span class="detail-value highlight">¥{{ withdrawData.remainingAmount }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="累计已提金额">
          <span class="detail-value highlight">¥{{ withdrawData.totalWithdrawn }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="处理状态">
          <span :class="getStatusClass(withdrawData.status)">{{ getStatusText(withdrawData.status) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="申请时间">
          <span class="detail-value">{{ withdrawData.applyTime }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="修改时间">
          <span class="detail-value">{{ withdrawData.updateTime }}</span>
        </el-descriptions-item>
        <el-descriptions-item v-if="withdrawData.rejectReason" label="拒绝原因">
          <span class="detail-value reject-reason">{{ withdrawData.rejectReason }}</span>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    
    <div v-else class="empty-state">
      <i class="el-icon-info"></i>
      <p>暂无数据</p>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'MerchantWithdrawalDetails',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    withdrawData: {
      type: Object,
      default: null
    }
  },
  computed: {
    localVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    drawerSize() {
      // 计算50%的宽度
      const windowWidth = window.innerWidth
      return Math.min(windowWidth * 0.5, 800) + 'px'
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    getStatusText(status) {
      const statusMap = {
        pending: '待处理',
        approved: '审核通过待支付',
        paid: '已支付',
        rejected: '已拒绝'
      }
      return statusMap[status] || status
    },
    getStatusClass(status) {
      const classMap = {
        pending: 'status-pending',
        approved: 'status-approved',
        paid: 'status-paid',
        rejected: 'status-rejected'
      }
      return classMap[status] || ''
    }
  }
}
</script>

<style scoped lang="scss">
.drawer-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.drawer-content {
  padding: 20px;
}

.detail-value {
  font-size: 14px;
  color: #606266;
}

.detail-value.highlight {
  color: #409EFF;
  font-weight: 600;
  font-size: 15px;
}

.reject-reason {
  color: #F56C6C;
}

// 状态颜色
.status-pending {
  color: #409EFF;
  font-weight: 600;
}

.status-approved {
  color: #E6A23C;
  font-weight: 600;
}

.status-paid {
  color: #909399;
  font-weight: 600;
}

.status-rejected {
  color: #F56C6C;
  font-weight: 600;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
  
  i {
    font-size: 48px;
    margin-bottom: 16px;
  }
  
  p {
    font-size: 14px;
    margin: 0;
  }
}

// 响应式适配
@media (max-width: 768px) {
  .drawer-content {
    padding: 12px;
  }
  
  ::v-deep .el-descriptions__label,
  ::v-deep .el-descriptions__content {
    padding: 8px 10px;
  }
}
</style>